var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn",class:[_vm.type,_vm.size],on:{"click":function($event){return _vm.toggleValue()}}},[_c('span',{staticClass:"marginal-left-m",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.displayTitle))}}),_c('span',{staticClass:"glyphicon glyphicon-ok marginal-left-m"})])
}
var staticRenderFns = []

export { render, staticRenderFns }